<div class="grid ">
    <div class="col-12">
        <div class="card">
            <form #f="ngForm" name="form" novalidate (paste)="onPaste($event)" (drop)="onDrop($event)"
                (dragover)="onDragOver($event)">
                <div class="formgroup">
                    <div class="flex justify-content-center" *ngIf="exibirSpinnerPrincipal">
                        <p-progressSpinner></p-progressSpinner>
                    </div>
                    <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                        <p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
                    </div>
                    <div class="p-fluid p-formgrid grid mb-3" *ngIf="!exibirSpinnerPrincipal">
                        <div class="col-12 md:col-12 pb-1">
                            <span class="text-xl font-semibold">{{chamadoSelecionado?.empresa?.nomeFantasia}} - </span>
                            <span class="text-lg">{{chamadoSelecionado?.empresa?.cnpjCpf | cnpjCpfFormat }}</span>
                        </div>
                        <div class="field col-12 md:col-12">
                            <span class="flex flex-column mb-3">
                                <label for="baseConhecimento" class="text-lg mb-2">
                                    <p-checkbox class="mr-1" [(ngModel)]="adicionadoBaseConhecimento" [binary]="true"
                                        inputId="baseConhecimento" name="baseConhecimento" #baseConhecimento>
                                    </p-checkbox>
                                    Adicionar à Base de de Conhecimento do Sistema?
                                </label>
                                <label htmlFor="descricao" class="text-xl">Descrição do encerramento</label>
                                <label for="" class="text-sm"><i class="text-sm pi pi-info-circle mr-1"></i>Essas
                                    informações serão utilizadas para a Base de Conhecimento
                                    no menu Suporte / Base de Conhecimento
                                </label>
                            </span>
                            <textarea class="text-xl" id="description" type="text" pInputTextarea [rows]="8"
                                [(ngModel)]="textoDescricaoChamado" style="resize: none" name="descricao"
                                #descricao></textarea>
                        </div>

                        <div class="col-12">
                            <div *ngIf="arquivosAnexados.length > 0"
                                class="flex flex-nowrap overflow-x-auto justify-start gap-3">
                                <div *ngFor="let arquivo of arquivosAnexados; let i = index"
                                    class="relative w-8rem h-8rem">

                                    <img *ngIf="arquivo.preview" [src]="arquivo.preview" [pTooltip]="arquivo.nome"
                                        class="object-cover w-full h-full rounded border-1 border-round border-gray-500" />
                                    <div *ngIf="arquivo.icone" [pTooltip]="arquivo.nome"
                                        class="flex align-items-center justify-content-center w-full h-full border-1 border-round border-gray-500">
                                        <i [ngClass]="arquivo.icone" class="text-4xl"></i>
                                    </div>
                                    <button pButton (click)="removerArquivo(i)" icon="pi pi-trash"
                                        class="p-button-danger absolute top-0 right-0 mt-1 mr-1 w-2rem h-2rem">
                                    </button>
                                </div>

                            </div>
                            <div
                                class="border-2 border-dashed border-gray-300 rounded-lg p-4 mt-2 text-center surface-100">
                                <i class="pi pi-upload text-4xl text-gray-500 mb-2 cursor-pointer"
                                    (click)="fileInput.click()"></i>
                                <p class="text-gray-700 font-medium cursor-pointer" (click)="fileInput.click()">Arraste
                                    e solte arquivos
                                    aqui ou cole com Ctrl+V</p>
                                <p class="text-xl text-gray-600">PNG, JPG, PDF, CSV, DOCX até 5MB</p>
                            </div>

                            <input #fileInput type="file"
                                accept="image/*, application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/csv"
                                multiple hidden (change)="onFileSelect($event)" />
                        </div>
                    </div>
                    <div class="p-fluid p-formgrid grid justify-content-between" *ngIf="!exibirSpinnerPrincipal">
                        <div class="col-12 md:col-4">
                            <button type="submit" pButton label="Encerrar"
                                class="p-button-outlined p-button-success md:w-13rem"
                                [icon]="progressoRequisicao ? 'pi pi-spin pi-spinner':'pi pi-check'"
                                [disabled]="!textoDescricaoChamado || progressoRequisicao || arquivosProcessando > 0"
                                (click)="encerrarChamado()">
                            </button>
                        </div>
                        <div class="col-12 md:col-4 flex justify-content-end">
                            <button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
                                class="p-button-outlined md:w-9rem" routerLink="/rfarias/suporte"></button>
                        </div>
                    </div>
                </div>
            </form>
            <p-dialog header="Chamado" [(visible)]="exibirRedirecionarEncerrado" [modal]="true"
                [style]="{width: '35vw'}" [draggable]="false" [resizable]="false" [closable]="true"
                (onHide)="redirecionarChamadoEncerrado()">
                <div class="flex justify-content-between">
                    <p>
                        Chamando foi encerrado com sucesso
                    </p>
                    <button type="button" pButton label="OK" class="p-button-primary"
                        (click)="redirecionarChamadoEncerrado()"></button>
                </div>
            </p-dialog>
        </div>
    </div>
</div>